module.exports = __webpack_public_path__ + "static/media/ICON_close_dark.20cbb412.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/ICON_close_dark.svg
// module id = 780
// module chunks = 0